<template>
        <div class="property-line">
            <h4 class="header">{{header}}</h4>
            <p class="line" contenteditable="true" @blur="handleInput" v-text="inputText"></p>   
        </div>
</template>

<script>
export default {
    name: 'property-line',
    props: {
        header:String,
        text: String
  },
  data:function(){
      return {
          inputText: this.text
      }
  },
  methods:{
      handleInput:function(e){
          this.inputText = e.target.innerText;
      }
  }
}
</script>

<style>
  /* :host {
    line-height: 1.4;
    display: table;
    text-indent: -1em;
    padding-left: 1em;
    float:left;
  } */
 .property-line{
    /* line-height: 1.4; */
    /* display: inline; */
    /* float:left; */
    display: inline-block;
    text-indent: -1em;
    padding-left: 1em;
  }

  h4.header{
     /* line-height: 1.4; */
    
    /* margin: 0; */
    /* display: inline; */
    /* display: table; */
    font-weight: bold;
    padding-right: 0.3em;
  }

  h4.header, p{
    /* vertical-align: top; */
    margin: 0;
    display: inline;  
  }

  p{
    text-indent: 1em;
  }

  p:first-of-type{
    /* display: inline;   */
    text-indent: 0;
  }  

  .line:hover{
    background-color: white;
  }
  .line:focus{
    background-color: white;
  }
</style>